export const menuLateralWidth = 357;

export const selectFieldStyleDisplayNone = {
    control: styles => ({ ...styles, display: 'none' }),
};

export const selectFieldStyle = {
    control: (styles, { isFocused }) => ({ ...styles, backgroundColor: 'white', boxShadow: null, borderColor: isFocused ? '#99bbff' : '#ccc' }),
};

export const selectFieldStyleError = {
    control: styles => ({ ...styles, backgroundColor: '#fff6f6', borderColor: '#e0b4b4', color: '#9f3a38' }),
    singleValue: styles => ({ ...styles, color: '#9f3a38' })
};

export const selectFieldWithNoIndicator = {
   ...selectFieldStyle,
    dropdownIndicator: styles => ({ ...styles, display: 'none' }),
    indicatorSeparator: styles => ({ ...styles, display: 'none' }),
}

export const selectFieldWithNoIndicatorError = {
    ...selectFieldStyleError,
    dropdownIndicator: styles => ({ ...styles, display: 'none' }),
    indicatorSeparator: styles => ({ ...styles, display: 'none' }),
}

export const tableCellAutorizado = {
    width: 83,
    color: '#7BC72A',
    fontFamily: "Work Sans",
    fontSize: 12,
    textAlign: 'center'
}

export const tableCellNegado = {
    width: 83,
    color: '#DF1F36',
    fontFamily: "Work Sans",
    fontSize: 12,
    textAlign: 'center'
}